// Resource names as constants
export const Documents = 'documents';
export const Accounts = 'accounts';
export const Shipments = 'shipments';
export const Contacts = 'contacts';
export const Tenants = 'tenants';
export const Settings = 'settings';
export const Orders = 'orders';
export const carriers = 'carriers';
export const payorTerms = 'payorterms';
export const Referencetypes = 'referencetypes';
export const ASN = 'asns';
export const Lanes = 'lanes';
export const transportService = 'transport';

//------------tenant------------
export const entitiesSearchUrl = '/entities/search';
export const contactsSearchUrl = `/${Contacts}/search`;
export const fetchUnitsOfMeasure = '/unitsofmeasures';
export const accountsUrl = `/${Accounts}`;
export const tenants = `/${Tenants}`;
export const fetchContactsUrl = `/${Contacts}`;
export const settingsUrl = `/${Settings}`;
export const getReferenceTypes = `${Settings}/referencetypes`;
export const fetchReferenceTypesUrl = `/${Referencetypes}`;
export const documentUploadUrl = `/${Documents}`;
export const downloadDocumentUrl = `/${Documents}/download`;
export const businessEntityUrl = '/businessentities';
export const contactAssociationEntity = '/businessentities/contacts/associate';
export const fetchTransportationModes = '/transportationmodes/';
export const fetchCarriers = `/${carriers}`;
export const fetchPayorTermsUrl = `/${payorTerms}/`;
export const fetchServiceChargesUrl = '/servicecharges/';
export const laneUrl = `/${Lanes}`;
export const fetchContactByIdUrl = `/${Contacts}/contactById`;
export const locationsUrl = '/locations';
export const locationUrl = '/locations';
export const tenantsUrl = `/${Tenants}`;
//------------tenant end------------

//------------shipment------------
export const shipmentSettingUrl = `/${Shipments}/settings`;
export const shipmentsUrl = `/${Shipments}`;
export const fetchShipmentByIdUrl = `/${Shipments}/`;
export const fetchShipments = `/${Orders}/${Shipments}`;
export const fetchMyWorkItemsSummary = `/v1${fetchShipments}/myworkitems`;
export const fetchMyWorkItemsDetails = `${fetchMyWorkItemsSummary}/details`;
export const fetchShipmentById = `/${Orders}/${Shipments}/shipmentId`;
export const fetchShipmentByNumber = `/${Orders}/${Shipments}/search/shipmentNumber`;
export const shipmentProofOfDeliveryUrl = `/${Orders}/orderId/${Shipments}/shipmentNumber/proofofdelivery`;
export const shipmentReferencesUrl = `/${Orders}`;
export const calculateTransitDaysUrl = `/${Orders}/calculate-transit-date`;

export const shipmentTracking = '/order/:shipmentId/tracking';
export const shipmentCheckCalls = '/order/:transportId/check-calls';
export const shipmentManagement = '/order/management';
export const expediteShipments = '/order/expedites';
export const shipmentDetails = '/order/:shipmentNumber/details';
export const shipmentManage = '/order/manage';
export const shipmentCreate = '/order/create';
export const asnList = '/order/asn';
export const asnCreate = '/order/asn/create';
export const orderDetails = '/order/:orderId/details';
export const orderManagement = '/order/management';
export const asnManagement = '/order/asn/management';
export const asnPreview = '/order/asn/preview';
export const asnDetailsPreview = '/order/asn/manage/preview';
export const fetchV1ASNUrl = `/v1/${ASN}`;
//------------shipment end------------

//------------tracking----------------
export const fetchTrackingById = '/tracking/';
export const fetchTrackedTransportsByIdUrl = '/tracking/transport';
export const updateProcessStatusUrl = '/tracking/transportLocationUpdates';

export const orderUrl = `/${Orders}`;
export const orderSettingUrl = `/${Orders}/settings`;
export const fetchOrderById = `/${Orders}/orderId`;
export const fetchOrderBySearchUrl = `/${Orders}/search/searchText`;
export const fetchOrderShipmentsTransportsUrl =
  '/orders/search/order-shipment-transport';
export const fetchOrderShipmentTransportReferencesUrl = `/${Orders}/:orderId/references`;

//------------quote------------
export const quotesUrl = '/quotes';
export const fetchQuotes = '/quotes';
export const fetchQuoteSettings = '/quotes/settings';
export const fetchQuoteAuditByStreamId = '/quotes/audit/';
export const quoteManagement = '/ordersquotations/quotemanagement';
export const fetchQuoteMyWorkItemsSummary = `/v1${quotesUrl}/myworkitems`;
// v1 PUT routes ({id}/update, {id}/approval) return 204 No Content
export const quotesV1Url = `/v1${quotesUrl}`;
//------------quote end------------

//------------lanes & logistics plan------------
// UI routes
export const lanesAndLogisticsPlan = '/laneslogisticsplan';
export const currentWeekSchedulesUrl = '/laneslogisticsplan/currentweek';
export const weeklyScheduleApprovalRequestUrl =
  '/laneslogisticsplan/approvalrequest';
export const approvedWeeklySchedulesUrl = '/laneslogisticsplan/approved';
export const lanesInLogisticsPlanUrl = '/laneslogisticsplan/lanes';
export const preAlertsAsnUrl = '/laneslogisticsplan/prealerts';
export const preAlertsAsnPreviewUrl =
  '/laneslogisticsplan/prealerts/:shipmentNumber/preview';
export const orderApprovalGroupsUrl = '/logisticplans/order-approval-groups';
// PUT only; v1 returns 204 No Content.
export const orderApprovalItemUpdateUrl = '/v1/orderapproval-itemupdate';
export const logisticPlansUrl = '/logisticplans';
export const weeklySchedulesUrl = '/weekly-schedules';
export const scheduleForALanesUrl = '/schedules';
//------------lanes & logistics plan end------------

//------------invoices------------
export const invoicesUrl = '/invoices';
export const invoiceDetails = '/invoices/:invoiceNumber';
//------------invoices end------------

//------------ftp users------------
export const ftpUsersUrl = '/ftpusers';
export const ftpUserDetails = '/ftpusers/:userName';
//------------ftp users end------------

//------------hazmat------------
export const searchHazmatUrl = '/hazmat/search';

//------------products------------
export const fetchProductsUrl = '/products';

//------------rates------------
export const fetchRatesUrl = '/rates';

export const fetchResourcesUrl = '/resources';
export const departmentsUrl = '/departments';

//------------Exceptions-----------
export const fetchExceptionsByLink = '/exceptions/by-link';

//ui
export const transportDetails =
  '/transportationplanning/manage/:transportId/transportdetails';

//------------damages & claims------------
export const damagesClaimsUrl = '/claims';
export const createDamagesClaimsUrl = '/claims/create';
//------------damages & claims end------------

export const contractsUrl = '/contracts';
export const createContractUrl = '/createcontract';
export const contractInformationUrl = '/contractinformation';
export const transportationModeUrl = '/transportationmodes';
export const transportsUrl = '/transports';
